import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { AiFillReconciliation } from 'react-icons/ai';
import CollectionItemHeader from '../layout/CollectionItemHeader';
import getTheme from '../../theme/theme';
import { useItems } from '../../hooks/atoms/items-hook';
import CollectionKeys from '../../hooks/molecules/collection-keys';
import DoctorKitsTable from './doctor-kits/DoctorKitsTable';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const DoctorKits = () => {
  const classes = useStyles();

  const {
    itemsLoading: kitsLoading,
    count: totalEntries,
  } = useItems(CollectionKeys.REGISTRATION_KITS, { filterQuery: { doctor_null: false }, queryOptions: { refetchOnWindowFocus: false } }, { doctor_null: false });

  return (
    <div className={ classes.root }>
      <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
        <AiFillReconciliation
          style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
          size={ 36 }
        />
        <CollectionItemHeader
          title='Doctor kit management'
          subtitle={ kitsLoading ? '' : `Entries: ${ totalEntries ?? 0 }` }
          actions={ (
            <>
            </>
          ) }
        />
      </div>
      <DoctorKitsTable />
    </div>
  );
};

export default DoctorKits;
